/**
 * Create a test logger with timestamps
 * @param {string} prefix - Log prefix
 * @returns {Object} Logger object
 */
export function createLogger(prefix = 'API') {
    return {
        info: (message: any) => console.log(`[${prefix}] ${new Date().toISOString()}: ${message}`),
        error: (message: any) => console.error(`[${prefix}] ${new Date().toISOString()}: ERROR: ${message}`),
        warn: (message: any) => console.warn(`[${prefix}] ${new Date().toISOString()}: WARN: ${message}`),
        debug: (message: any) => {
            if (process.env['DEBUG']) {
                console.log(`[${prefix}] ${new Date().toISOString()}: DEBUG: ${message}`)
            }
        }
    }
}